import client from './client';
import qs from 'qs';

/**
 * 새창링크설정 - 리스트
 */
export const SetLinkList = (param) =>
  client.get(`/api/manage/setlink/list`, param);

/**
 * 새창링크설정 - 등록
 */
export const addLink = (title, domains) =>
  client.post(`/api/manage/setlink/write`, qs.stringify(title, domains));

/**
 * 새창링크설정 - 수정
 */
export const SetLinkEdit = (title, domains, seq) =>
  client.post(`/api/manage/setlink/edit`, qs.stringify(title, domains, seq));

/**
 * 새창링크설정 - 삭제
 */
export const SetLinkDel = (seq) =>
  client.delete(`/api/manage/setlink/del`, { data: seq });
